var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("font-awesome-icon", {
    attrs: {
      icon: _vm.$v7.solid[_vm.selectedSpinner],
      size: _vm.size,
      spin: "",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }